import { render, staticRenderFns } from "./NavbarFixed.vue?vue&type=template&id=6511b445&"
import script from "./NavbarFixed.vue?vue&type=script&lang=js&"
export * from "./NavbarFixed.vue?vue&type=script&lang=js&"
import style0 from "./NavbarFixed.vue?vue&type=style&index=0&id=6511b445&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports